import React, { useState } from "react";
import { mergePacientes } from "../../../../services/pacientes";
import "../DashboardHistoriaClinica.css";

const ModalMergePacientes = ({ isOpen, onClose, pacientes = [], onUpdated }) => {
  const [pacienteOrigenId, setPacienteOrigenId] = useState("");
  const [pacienteDestinoId, setPacienteDestinoId] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const getNombrePaciente = (paciente) => {
    if (!paciente) return "";
    return `${paciente.nombre || ""} ${paciente.apellido_paterno || ""} ${paciente.apellido_materno || ""}`.trim();
  };

  const handleClose = () => {
    setPacienteOrigenId("");
    setPacienteDestinoId("");
    onClose();
  };

  const handleSubmit = async () => {
    if (!pacienteOrigenId || !pacienteDestinoId) {
      alert("Selecciona paciente origen y paciente destino.");
      return;
    }

    if (pacienteOrigenId === pacienteDestinoId) {
      alert("El paciente origen y destino no pueden ser el mismo.");
      return;
    }

    const origen = pacientes.find((p) => p.id === pacienteOrigenId);
    const destino = pacientes.find((p) => p.id === pacienteDestinoId);

    const confirmar = window.confirm(
        
            `Paciente origen: ${getNombrePaciente(origen)}\n` +
            `Paciente destino: ${getNombrePaciente(destino)}\n\n` +
            `El paciente origen dejará de aparecer y sus registros se moverán al paciente destino.\n\n` +
            `Esta acción es irreversible. ¿Deseas continuar?`
        );

        if (!confirmar) return;

        const confirmarFinal = window.confirm(
        
            `¿Estás seguro de realizar esta fusión?\n\n` +
            `Esta acción no es reversible.`
        );

        if (!confirmarFinal) return;
    try {
      setLoading(true);

      await mergePacientes(pacienteOrigenId, pacienteDestinoId);

      alert("Pacientes fusionados correctamente.");

      setPacienteOrigenId("");
      setPacienteDestinoId("");

      if (onUpdated) onUpdated();
      onClose();
    } catch (error) {
      const msg =
        error?.response?.data?.detail ||
        "No se pudo fusionar el paciente. Intenta nuevamente.";

      alert(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Fusionar pacientes</h3>

       <p>
        Usa esta herramienta únicamente cuando tengas dos registros del mismo paciente
        y quieras dejar uno solo como expediente final.
        </p>

        <p>
        <strong>Paciente origen:</strong> es el registro duplicado o incorrecto que
        quieres fusionar. Este paciente dejará de aparecer en tu lista.
        </p>

        <p>
        <strong>Paciente destino:</strong> es la ficha del paciente con la que te vas
        a quedar. Sus datos generales serán los que se conserven como ficha de identificación principal.
        </p>

        <p>
        Al confirmar la fusión, la información clínica y operativa del paciente origen
        se moverá al paciente destino para concentrar todo en un solo expediente.
        </p>

        <p>
        Por favor revisa muy bien cuál eliges como destino, porque esta acción no se podrá
        revertir.
        </p>

        <label>Paciente origen</label>
        <select
          value={pacienteOrigenId}
          onChange={(e) => setPacienteOrigenId(e.target.value)}
        >
          <option value="">Selecciona paciente origen</option>
         {pacientes
            .filter((paciente) => paciente.id !== pacienteDestinoId)
            .map((paciente) => (
                <option key={paciente.id} value={paciente.id}>
                {getNombrePaciente(paciente)}
                </option>
            ))}
        </select>

        <label>Paciente destino</label>
        <select
          value={pacienteDestinoId}
          onChange={(e) => setPacienteDestinoId(e.target.value)}
        >
          <option value="">Selecciona paciente destino</option>
         {pacientes
            .filter((paciente) => paciente.id !== pacienteOrigenId)
            .map((paciente) => (
                <option key={paciente.id} value={paciente.id}>
                {getNombrePaciente(paciente)}
                </option>
            ))}
        </select>

        <p style={{ marginTop: "12px", fontWeight: "bold" }}>
          Esta acción es irreversible.
        </p>

        <div className="modal-buttons">
          <button
            className="cancel-button"
            onClick={handleClose}
            disabled={loading}
          >
            Atrás
          </button>

          <button
            className="confirm-button"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Fusionando..." : "Fusionar pacientes"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalMergePacientes;